import { useMemo } from 'react';
import clsx from 'clsx';
import CustomTooltip from '@components/ringil3/Tooltip/CustomTooltip.tsx';
import SvgQuestionMark from '@icons/question-mark.svg?react';

interface FieldLabelProps {
  label?: string;
  helpText?: string;
  mode?: 'error' | 'disabled' | 'readOnly' | 'normal' | 'required';
}

export const FieldLabel: React.FC<FieldLabelProps> = ({ label, helpText, mode = 'normal' }) => {
  const randomId = useMemo(() => helpText ? crypto.randomUUID() : undefined, [helpText]);

  return (
    <div className={clsx(
      "flex gap-2 items-center my-2",
      mode === 'readOnly' && "[&_span.p-inputtext]:text-content-tertiary [&_div]:text-content-tertiary"
    )}>
      <div className="font-medium text-sm leading-3 text-primary">
        {label}
      </div>
      {helpText && (
        <div
          id={`helpText_${randomId}`}
          className="relative flex h-3 w-3 rounded-full items-center justify-center bg-content-quaternary"
        >
          <SvgQuestionMark className="h-2.5 w-2.5 text-content-secondary" />
          <CustomTooltip
            targetSelector={`#helpText_${randomId}`}
            content={helpText}
          />
        </div>
      )}
    </div>
  );
};